export default "__VITE_ASSET__CP3oez5B__"